import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '../../../../../components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../../components/ui/table';
import ReviewsTableRow from './ReviewsTableRow';

function ReviewsTable({ reviews, onReview }) {
  return (
    <Card style={{ border: '1px solid hsl(var(--border))' }}>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[50px]" />
              <TableHead className="min-w-[200px]">User</TableHead>
              <TableHead className="text-center">Goal</TableHead>
              <TableHead className="text-center">Requested</TableHead>
              <TableHead className="w-[120px]" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {reviews.map((review) => (
              <ReviewsTableRow key={review._id} review={review} onReview={onReview} />
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

ReviewsTable.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      goal: PropTypes.string.isRequired,
      user: PropTypes.shape({
        email: PropTypes.string.isRequired,
        avatar: PropTypes.shape({}).isRequired,
      }).isRequired,
      createdAt: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onReview: PropTypes.func.isRequired,
};

export default ReviewsTable;
